var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting_main_contents", attrs: { id: "job-main-content" } },
    [
      _c("div", { class: { overlay_setting: _vm.isLoadingData } }, [
        _c("i", { class: { loadding_setting: _vm.isLoadingData } })
      ]),
      _c(
        "div",
        { staticClass: "setting_heading" },
        [
          _c("h1", { staticClass: "setting_heading_title" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.jobSettingProperty.TAB_HEADER) + "\n    "
            )
          ]),
          _c("p", { staticClass: "setting_heading_explain" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.jobSettingProperty.SUB_HEADER) + "\n    "
            )
          ]),
          _c(
            "button",
            {
              staticClass: "setting_btn_outline",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.openModalPreview($event)
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.jobSettingProperty.PREVIEW_BUTTON) +
                  "\n    "
              )
            ]
          ),
          _c("PreviewDisplay", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isVisibleModalPreview,
                expression: "isVisibleModalPreview"
              }
            ],
            attrs: {
              button: _vm.button,
              categoriesSearchJob: _vm.jobSearchForm.categorySetting,
              colors: _vm.searchColors,
              masters: _vm.masters,
              jobPageName: _vm.jobPageName,
              jobOverview: _vm.jobOverview,
              numberOfJobDisplay:
                _vm.jobSearchForm.displaySetting.displayRecord,
              headingSettings: _vm.headingSettings,
              bodySettings: _vm.bodySettings,
              categoriesJobList: _vm.jobListForm.categorySetting,
              categoriesJobDetail: _vm.jobDetailForm.categorySetting,
              commonSetting: _vm.commonSetting
            },
            on: { close: _vm.closeModalPreview }
          })
        ],
        1
      ),
      _c("div", { staticClass: "setting_tab" }, [
        _c("div", { staticClass: "setting_tab_nav" }, [
          _c("ul", { staticClass: "setting_tab_nav_list" }, [
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item is_active",
                attrs: { id: "t6" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.BUTTON_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.jobSettingProperty.BUTTON_TAB_TITLE) +
                      "\n          "
                  )
                ])
              ]
            ),
            _c(
              "li",
              {
                staticClass: "setting_tab_nav_item",
                attrs: { id: "t7" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.changeNavTab(_vm.COLOR_THEME_TAB)
                  }
                }
              },
              [
                _c("span", { staticClass: "setting_tab_nav_text" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.jobSettingProperty.COLOR_THEME_TAB_TITLE) +
                      "\n          "
                  )
                ])
              ]
            )
          ])
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.BUTTON_TAB,
                expression: "navTab === BUTTON_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("ButtonTab", {
                  attrs: {
                    button: _vm.button,
                    buttonError: _vm.buttonError,
                    displaySettingJobList: _vm.jobListForm.displaySetting,
                    displaySettingJobDetail: _vm.jobDetailForm.displaySetting
                  },
                  on: { updatedButtonError: _vm.updatedButtonError }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.navTab === _vm.COLOR_THEME_TAB,
                expression: "navTab === COLOR_THEME_TAB"
              }
            ],
            staticClass: "setting_tab_content"
          },
          [
            _c(
              "div",
              { staticClass: "setting_tab_content_panel is_active" },
              [
                _c("CustomizeMode", {
                  attrs: {
                    categoriesSearchJob: _vm.jobSearchForm.categorySetting,
                    colors: _vm.searchColors,
                    masters: _vm.masters,
                    button: _vm.button,
                    groupName: _vm.groupName,
                    selectedTheme: _vm.selectedTheme,
                    searchCustomizeSettings: _vm.searchCustomizeSettings,
                    detailCustomizeSettings: _vm.detailCustomizeSettings,
                    jobPageName: _vm.jobPageName,
                    jobOverview: _vm.jobOverview,
                    userId: _vm.log.info.userId,
                    token: _vm.token,
                    numberOfJobDisplay:
                      _vm.jobSearchForm.displaySetting.displayRecord,
                    headingSettings: _vm.headingSettings,
                    bodySettings: _vm.bodySettings,
                    categoriesJobList: _vm.jobListForm.categorySetting,
                    categoriesJobDetail: _vm.jobDetailForm.categorySetting,
                    commonSetting: _vm.commonSetting
                  },
                  on: {
                    updateCustomizeColors: _vm.updateCustomizeColors,
                    updatedSelectedTheme: _vm.updatedSelectedTheme,
                    refreshCustomizeSetting: function($event) {
                      return _vm.refreshCustomizeSettings($event)
                    },
                    createLogger: function($event) {
                      return _vm.createLogger($event)
                    },
                    sendLogger: _vm.sendLogger
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "setting_footer", attrs: { id: "setting_footer" } },
        [
          _c(
            "button",
            {
              staticClass: "setting_btn_outline",
              on: {
                click: function($event) {
                  return _vm.cancelChangeJobDataSetting()
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.jobSettingProperty.CANCEL_BUTTON) +
                  "\n    "
              )
            ]
          ),
          _c(
            "button",
            {
              staticClass: "setting_btn_primary",
              class: {
                setting_btn_disabled: _vm.isDisableSaveBtn
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.jobSettingProperty.SAVE_BUTTON) +
                  "\n    "
              )
            ]
          ),
          _vm.unSavedData
            ? _c("div", { staticClass: "setting_footer_balloon" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.jobSettingNotifyProperty.SAVE_CHANGE_DATA) +
                    "\n    "
                )
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }